import { all, takeLatest } from 'redux-saga/effects'

import * as actions from './selectLists.actions'
import { fetchSelectListsSaga } from './sagas/fetch-select-lists'

export default function* () {
  yield all([takeLatest(actions.FETCH_SELECT_LISTS_REQUEST, fetchSelectListsSaga)])
}
